import React, {Component} from 'react';
import GameColumn from './gamecolumn';
import Levels from '../../src/data';
import { connect } from "react-redux";
import { setGameOptions } from "../actions";

class WordGrid extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   syllablesComplete: 1
    // };
  }
  handleCloseModal () {
    this.setState({ showModal: false });
  }
	render(){
    //TODO: potentially pass in syllables as props
    // this.props.setGameOptions({ needs_review: true });  
    const emptyGrid = [{},{},{},{},{}]
    const syllables = this.props.word.korword.split("");

    const syllableFilledGrid = emptyGrid.map((val, key) => {
      if(syllables[key]!==undefined){
        return syllables[key];
      }else{
        return undefined
      }
    })
		//load tiles with syllables
    const { keySyllable, altChar } = this.props.word;
    let isKeySyllable = false;
    // ensure words like 일요일 don't get tagged with two key syls
    let keySyllableSet = false;
		const wordGrid = syllableFilledGrid.map((syllable, key) => {
      if(isKeySyllable) { isKeySyllable = false };
      //loop through syllables and mark key if true
      if (syllable !== undefined && !keySyllableSet) {
        isKeySyllable = ( syllable === keySyllable || syllable === altChar );
        keySyllableSet = isKeySyllable;
        console.log('durr', isKeySyllable)
      }
      return (
        <GameColumn
          checkWordComplete={this.props.checkWordComplete}
          key={"col " + key}
          id={key}
          showMistake={this.props.showMistake}
          minipad={syllables.length}
          currentWord={this.props.currentWord}
          syllable={syllable}
          keySyllable={ isKeySyllable }
          first={key===0}
          last={key===syllables.length - 1} 
        />
      )
		})
		return(
			<div className="game-grid-container">
          
          {wordGrid}

      </div>
		)
	}
}



const mapStateToProps = ({ GameOptions} ) => {
  return {
    currentWord: GameOptions.current_word,
    unlockedLevel: GameOptions.unlocked_level
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGameOptions: GameOptions => {
      dispatch(setGameOptions(GameOptions));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WordGrid);



// WEBPACK FOOTER //
// ./src/components/wordgrid.js